import { render, staticRenderFns } from "./SuppliesMonthlyInvntry.vue?vue&type=template&id=638694dd&scoped=true&"
import script from "./SuppliesMonthlyInvntry.vue?vue&type=script&lang=js&"
export * from "./SuppliesMonthlyInvntry.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesMonthlyInvntry.vue?vue&type=style&index=0&id=638694dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638694dd",
  null
  
)

export default component.exports